// Granular feature flags for billing sub-features
// Each sub-feature can be independently enabled/disabled

export const BILLING_FEATURES = {
    gifts: process.env.REACT_APP_ENABLE_BILLING_GIFTS !== 'false', // Default: enabled
    seats: process.env.REACT_APP_ENABLE_BILLING_SEATS !== 'false', // Default: enabled
    referrals: process.env.REACT_APP_ENABLE_BILLING_REFERRALS !== 'false', // Default: enabled
}

// Helper to check if a specific feature is enabled
export const isBillingFeatureEnabled = (feature: keyof typeof BILLING_FEATURES): boolean => {
    return BILLING_FEATURES[feature]
}
